export default {
  SET_STAFFS: function (state, payloads) {
    state.staffs = payloads;
  }
}
